import * as actionTypes from './actionTypes'

export const fetchHowItWorksData = payload => ({
    type: actionTypes.fetchHowItWorksType,
    payload
  });
  